export const ModalDialogMessages = {
  cancelModal: {
    title: {
      id: 'cancelModal.Title',
      defaultMessage: 'Are you sure?',
    },
    message: {
      id: 'cancelModal.Message',
      defaultMessage: 'You\'ll lose any changes you\'ve made.',
    },
    submitBtnText: {
      id: 'cancelModal.SubmitButtonText',
      defaultMessage: 'Yes, I want to cancel',
    },
    submitBtnTextDescription: {
      id: 'cancelModal.SubmitButtonText.Description',
      defaultMessage: 'Opens a new screen',
    },
    hideBtnText: {
      button: {
        id: 'cancelModal.HideButtonText.Button',
        defaultMessage: 'No, take me back',
      },
      description: {
        id: 'cancelModal.HideButtonText.Description',
        defaultMessage: 'Closes dialog.',
      },
    },
  },
};
